import React, { Component } from 'react';
import { notification, Table, Modal } from 'antd';
import { PageContainer } from '@ant-design/pro-layout';
import dashboardService from 'services/dashboard.service';
import { formatDateForClient, formatMoney } from 'helpers/utils';
import { AuthContext } from 'context/AuthContext';
import { NavLink } from 'react-router-dom';
import 'antd/dist/reset.css';
import dayjs from 'dayjs';

class PaymentDetails extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      loading: false,
      currentMerch: context?.selectedMerch,
      startDate: formatDateForClient(dayjs().subtract(2, 'years')),
      endDate: formatDateForClient(),
      modalVisible: false,
      columns: [
        {
          title: <div className="table-title-calibri-bold-12">Banka/Banka IBAN Bilgisi</div>,
          dataIndex: 'Bank',
          key: 'Bank',
          align: 'center',
          width: 250,
          render: (text, row) => (
            <span className="table-title-calibri-bold-12">
              {row.Bank} - {row.IBAN}
            </span>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">Fatura No</div>,
          dataIndex: 'RelatedInvoiceNumber',
          key: 'RelatedInvoiceNumber',
          align: 'center',
          width: 200,
          render: (text, row) => (
            <span className="table-title-calibri-bold-12">{row.RelatedInvoiceNumber}</span>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">Ödeme Tutarı</div>,
          dataIndex: 'PaymentAmount',
          key: 'PaymentAmount',
          align: 'center',
          width: 110,
          render: (text, row) => (
            <span className="table-title-calibri-bold-12">
              {row.PaymentAmount ? `${formatMoney(row.PaymentAmount)}` : ''}
            </span>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">Ödeme Tarihi</div>,
          dataIndex: 'Date',
          key: 'Date',
          width: 160,
          render: (text, row) => (
            <span className="table-title-calibri-bold-12">
              {row.Date ? dayjs(row.Date).format('DD.MM.YYYY HH:mm') : ''}
            </span>
          ),
        },
      ],
    };
  }

  componentDidMount() {
    this.getInvoices();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState?.currentMerch?.number !== this.context?.selectedMerch?.number &&
      this.state?.currentMerch?.number === prevState.currentMerch?.number
    ) {
      this.getInvoices();
    }
  }

  getInvoices = () => {
    this.setState({ loading: true, currentMerch: this.context?.selectedMerch }, async () => {
      const { currentMerch } = this.state;
      if (currentMerch?.number) {
        try {
          const { payload } = await dashboardService.getDashboardPaymentReports(
            currentMerch?.number,
          );
          this.setState({ data: payload, loading: false });
        } catch (error) {
          notification.error({
            message: 'İşlem Başarısız!',
            description: error,
          });
          this.setState({ loading: false });
        }
      }
    });
  };

  handleCloseForm = () => {
    this.setState({ modalVisible: false, partialReports: [] });
  };

  render() {
    const { columns, data, loading, partialReports, partialColumns, modalVisible } = this.state;

    return (
      <>
        <PageContainer
          title="Ödeme Detayları"
          footer={[
            <div
              key="footer-link"
              style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
            >
              <NavLink to="/odemeler-ve-faturalar/odemeler">
                <span style={{ color: 'blue', fontSize: 15 }}>Ödemeler</span>
              </NavLink>
            </div>,
          ]}
        >
          <Table
            loading={loading}
            dataSource={data}
            columns={columns}
            pagination={false}
            size="small"
            rowKey={(record, index) => index}
          />
        </PageContainer>

        <Modal
          width={1400}
          open={modalVisible}
          footer={false}
          title="Ödeme Detayları"
          onCancel={this.handleCloseForm}
          destroyOnClose
        >
          <Table
            loading={loading}
            dataSource={partialReports}
            columns={partialColumns}
            pagination
            rowKey={(record, index) => index}
          />
        </Modal>
      </>
    );
  }
}

PaymentDetails.contextType = AuthContext;
export default PaymentDetails;
